import { TDuplicatedOrganization } from "@/api/services/admin/organization/dtos/check-organization-name.dto";
import { Modal } from "@/components/elements/Modal";
import { AppRoutes } from "@/routes/config";
import { state, text } from "@/theme/colors";
import { getDynamicRoute } from "@/utils/url";
import { Stack, Typography } from "@mui/material";
import { FC } from "react";
import { Link as RouterLink } from "react-router-dom";

type TDuplicateOrganizationNameModalProps = {
  open: boolean;
  duplicates: TDuplicatedOrganization[];
  isLoading?: boolean;
  onClose: () => void;
  onConfirm: () => void;
};

const DuplicateOrgItem: FC<{ duplicate: TDuplicatedOrganization }> = ({ duplicate }) => (
  <Typography
    component="li"
    variant="sub16"
    color={text.primary}
    sx={{ "&::marker": { color: text.primary }, "& a": { color: state.link_1, textDecoration: "underline" } }}
  >
    <RouterLink to={getDynamicRoute(AppRoutes.organizationDetail, { id: String(duplicate.id) })} target="_blank" rel="noopener noreferrer">
      {duplicate.name}
    </RouterLink>
  </Typography>
);

export const DuplicateOrganizationNameModal: FC<TDuplicateOrganizationNameModalProps> = ({ open, duplicates, isLoading, onClose, onConfirm }) => {
  return (
    <Modal
      isOpen={open}
      onClose={onClose}
      onOk={onConfirm}
      isLoadingOkBtn={isLoading}
      title="確認"
      labelClose="キャンセル"
      labelOk="保存"
      justifyBtnAction="space-between"
      width={560}
    >
      <Stack gap={1.5} mb={2}>
        <Typography variant="body14" color={text.primary}>
          同名の組織が登録されています。確認してください。
        </Typography>
        <Stack component="ul" sx={{ pl: 3, m: 0 }} maxHeight={500} overflow="auto">
          {duplicates.map((dup) => (
            <DuplicateOrgItem key={dup.id} duplicate={dup} />
          ))}
        </Stack>
      </Stack>
    </Modal>
  );
};
